import { useForm } from "react-hook-form";
import { CirclePlus } from "lucide-react";

import CenteredHeading from "../../../components/UI/headingsUI/CenteredHeading";
import GrayButton from "../../../components/UI/buttonUI/GrayButton";
import DialogBox from "../../../components/UI/DialogBox";
import SearchDropdown from "../../../components/UI/PageInput/SearchDropdown";
import successIcon from "../../../assets/icons/successIcon.svg";
import PrimaryButton from "../../../components/UI/buttonUI/PrimaryButton";

const AssignMachineForm = ({
  machineSetup,
  sendData,
  successResponse,
  loading,
  navigate,
}) => {
  const isDataEmpty =
    !machineSetup.stations.length || !machineSetup.machines.length;

  const {
    handleSubmit,
    setValue,
    control,
    watch,
    formState: { errors },
    reset,
  } = useForm();

  const onSubmit = (data) => {
    sendData(data, reset);
  };

  return (
    <>
      <div className="form-container">
        <CenteredHeading title="Assign Machine to Station" />
        <form
          onSubmit={!loading ? (e) => handleSubmit(onSubmit)(e) : undefined}
        >
          <div className="flex flex-wrap">
            <div className="leftCol mx-auto pr-0">
              <SearchDropdown
                name="stationId"
                label="Station Name *"
                keyName="name"
                id="id"
                options={machineSetup.stations}
                setValue={setValue}
                control={control}
                selectedVal={watch("stationId")}
                render={successResponse}
                error={errors.stationId}
                disabled={!machineSetup.stations.length}
                search={true}
              />
              {!machineSetup.stations.length && (
                <p className="machinesErr">All Stations Assigned</p>
              )}
              <SearchDropdown
                name="machineId"
                label="Machine ID *"
                keyName="id"
                id="id"
                options={machineSetup.machines}
                setValue={setValue}
                control={control}
                selectedVal={watch("machineId")}
                render={successResponse}
                error={errors.machineId}
                disabled={!machineSetup.machines.length}
                search={true}
                optionListIsNumber={true}
              />
              {!machineSetup.machines.length && (
                <p className="machinesErr">All Machine Assigned</p>
              )}
            </div>
          </div>
          <div className="addBtn---wrap gap-2">
            <PrimaryButton
              btnText={!loading ? "Assign Machine" : "Adding..."}
              loading={loading}
              Icon={CirclePlus}
              size={18}
              isDisabled={isDataEmpty}
            />
            <GrayButton btnText="Clear" width="w-40" onClick={() => reset()} />
          </div>
        </form>
      </div>
      {successResponse && (
        <DialogBox
          message={`Successfully  Machine Assigned!`}
          messageIcon={successIcon}
          btnText="Ok"
          closeAction={() => navigate("/site/all")}
        />
      )}
    </>
  );
};
export default AssignMachineForm;
